import { Button, Col, Row } from 'react-bootstrap'
import {Input, Select} from '../../../../common/inputs/index.js'
import { HeaderTitle } from '../../../../common/HeaderTitle.jsx'
import { useState } from 'react'
import { optionsKategoriaProjektu } from '../../../../utils/options.js'
import { useInicjujProjekt } from '../../../../../api/domain/elementyRejstru/mutations/useInicjujProjekt.jsx'
import { useParams } from 'react-router-dom'
import { useProjektData } from '../../../../../api/domain/elementyRejstru/queries/useProjektData.jsx'
import { useEffect } from 'react'
import { useSelector } from 'react-redux'

const ViewInicjujForm = () => {
    const titleName = 'Dodaj nową kartę projektu'
    const [form, setForm] = useState({})
    const updateForm = (key, value) =>
        setForm((prevState) => ({ ...prevState, [key]: value }))
    const { id } = useParams()

    const [errors, setErrors] = useState([])
    const inicjuj = useInicjujProjekt(setErrors)

    const { data: projekt } = useProjektData(id, !!id)
    const rola = useSelector((state) => state.user.role)

    useEffect(() => {
        if (projekt) {
            setForm(projekt)
        }
    }, [projekt])

    return (
        <>
            <HeaderTitle
                breadcrumbLinks={[
                    {label: 'Wszystkie projekty', to: `/${rola}/rejestr/lista`},
                    {label: titleName}
                ]}
                home
                nav
                destination={`/${rola}/rejestr/lista`}
                size={'fs-3'}
                title={titleName}
            />
            <Row>
                <Col>
                    <Input
                        label={'Tytuł'}
                        onChange={(e) => updateForm('tytul', e.target.value)}
                        value={form.tytul}
                        errorText={errors?.tytul}
                        limit={460}
                    />
                </Col>
            </Row>
            <Row>
                <Col sm={2}>
                    <Select
                        label={'Kategoria'}
                        errorText={errors?.kategoria}
                        options={optionsKategoriaProjektu}
                        value={form.kategoria}
                        onChange={(e) =>
                            updateForm('kategoria', e.target.value)
                        }
                    />

                </Col>
            </Row>
            <div className={'d-flex'}>
                <Button
                    disabled={inicjuj.isPending}
                    className={'m-2'}
                    onClick={() => inicjuj.mutate(form)}
                >
                    {' '}
                   Zapisz
                </Button>
            </div>
        </>
    )
}

export default ViewInicjujForm
